<!--
    描述： 分析图表
    时间： 2020-05-28
    created by 张卫华
-->
<template>
    <div class="h100 main-page">
        <!-- 饼状图 -->
        <div class="pie-chart" v-show="chartType=='pie'">
            <div class="title" v-if="rowNodeLevel === 0">
                <el-button type="text" class="btn-text mr10" @click="showTotalOrEstimate('total')">总概算</el-button>
                /
                <el-button type="text" class="btn-text" @click="showTotalOrEstimate('estimate')">建安概算</el-button>
            </div>
            <div class="title" v-else>
                <el-button type="text" class="btn-text">建安概算</el-button>
            </div>
            <div class="chart-component text-center chart1" id="budgetChart"></div>
            <div class="chart-component text-center chart2" id="controlChart"></div>
            <div class="chart-component text-center chart3" id="bidChart"></div>
            <div class="chart-component text-center chart4" id="reportChart"></div>
            <div class="chart-component text-center chart5" id="primeChart"></div>
            <div class="chart-component text-center chart6" id="confirmChart"></div>
        </div>

        <!-- 柱状图 -->
        <div class="bar-chart" v-show="chartType=='bar'">
            <div class="bar-chart-component text-center chart6" id="barChart"></div>
        </div>

        <div class="big-picture-modal text-center" v-if="showBigger">
            <div class="content">
                <h3 class="title">大图查看<em class="el-icon-close" @click="showBigger = false"></em></h3>
                <div id="enlarge_chart" class="enlargeChart"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {getProjectCostAnalysis,getTotalEstimate, sixCalculationAnalysis} from '@/api/modules/analysisCharts'
import {treeToJson, dateFormatCN} from '@/utils/tools'
import analysisJsonData from '@/api/modules/analysisCharts.json'
const jsonData = analysisJsonData
export default {
	name: '',
    props: {

    },
    data() {
        return {
            chartPriceArr : [
                {key: 'budgetPrice', value: '1007001'},
                {key: 'controlPrice', value: '1007002'},
                {key: 'bidPrice', value: '1007003'},
                {key: 'reportPrice', value: '1007004'},
                {key: 'primePrice', value: '1007005'},,
                {key: 'confirmPrice', value: '1007006'},
            ],
            chartType : 'pie',

            rowNodeShowName : '',
            rowNodeName : '',
            rowNodeId : '',
            rowNodeLevel : '',
            totalEstimateData : [],

            listData : [],
            originalData : [],

            showBigger : false,

            budgetChart : null,
            controlChart : null,
            bidChart : null,
            reportChart : null,
            primeChart : null,
            confirmChart : null,
            barChart : null,
            enlargeChart : null,
        }
    },
    watch: {},
    computed: {
        // 当前的 项目Id
        curProjectId() {
            return this.$route.query.projectId
        },
        /*
        // 转化之后的 json 数据
        listData() {
            return treeToJson(this.originalData, 'pid')//Convert.treeToJson(this.originalData)
        }
        */
        // 当前导出人
        userName() {
            return this.$route.query.userName
        }
    },
    mounted() {

    },
    created() {
        //获取总概算
        this.getTotalData()
    },
    methods: {
        getTotalData(){
            this.totalEstimateData = []
            getTotalEstimate({ projectId: this.curProjectId }).then(res => {
                this.totalEstimateData = res.data.param
            })
            .catch(err => {})
        },
        rowClickInitEChart(row, chartType, rowNodeShowName, rowNodeName){
            this.showBigger = false
            this.chartType = chartType
            this.rowNodeLevel = row.levelType
            this.rowNodeName = row.sname
            this.rowNodeId = row.id
            this.rowNodeShowName = rowNodeShowName

            //获取分析图表数据信息

            if(this.listData.length == 0){
                this.getChartsData(chartType);
            }else{
                this.initCharts(chartType, this.rowNodeId)
            }
        },

        initNodeLeave3BudgetList(nodeLeave3List){
            let nodeLeave3BudgetList = nodeLeave3List.map((item) => {
                let cv = JSON.parse(JSON.stringify(item))
                cv.proTreeId = ''
                cv.detailId = ''
                cv.unitId = ''
                cv.unitCostBase = '0.00'
                cv.unitCostValue = 0.00;
                cv.unitCostRate = 0.00;
                cv.phase = '1007001'
                cv.phaseName = '概算价'
                return cv;
            });

            return nodeLeave3BudgetList
        },
        //项目结构0、1、2层级，计算累加子节点价格
        projectStructureLevel0l2PriceSum(analysisData){
            let resultList = []
            //计算项目结构树第三层级价格（proTreeLevelType = 2），累加proTreeLevelType=3的价格
            let list = analysisData.concat()
            let budgetIndex = list.findIndex((v, index, arr) => { return v != null && v.phase == '1007001' && v.unitParentId != 0 && v.proTreeName.substring(0,6) != "工程造价调整"})   //概算价
            let controlIndex = list.findIndex((v, index, arr) => {return v != null && v.phase == '1007002' && v.unitParentId != 0 && v.proTreeName.substring(0,6) != "工程造价调整"})  //控制价
            let bidIndex = list.findIndex((v, index, arr) => {return v != null && v.phase == '1007003' && v.unitParentId != 0 && v.proTreeName.substring(0,6) != "工程造价调整"})      //中标价
            let reportIndex = list.findIndex((v, index, arr) => {return v != null && v.phase == '1007004' && v.unitParentId != 0 && v.proTreeName.substring(0,6) != "工程造价调整"})   //报审价
            let primeIndex = list.findIndex((v, index, arr) => {return v != null && v.phase == '1007005' && v.unitParentId != 0 && v.proTreeName.substring(0,6) != "工程造价调整"})    //初审价
            let confirmIndex = list.findIndex((v, index, arr) => {return v != null && v.phase == '1007006' && v.unitParentId != 0 && v.proTreeName.substring(0,6) != "工程造价调整"})  //审定价
            let nodeLeave2List = list.filter(v=> {return v != null && v.proTreeLevelType==2})
            nodeLeave2List.forEach(v=>{     //金额取值bus_cost_detail_unit pid=0 ==> proTreeLevelType==3 && unitParentId==0
                let nodeLeave3BudgetList = []
                if(controlIndex > -1) { //控制价
                    //第4层信息
                    let nodeLeave3List = list.filter(function(sv) {return sv != null && sv.proTreeLevelType==3 && sv.proTreeParentId == v.proTreeId && sv.phase == '1007002' && sv.unitParentId!=0 && sv.proTreeName.substring(0,6) != "工程造价调整"})
                    if(nodeLeave3List.length > 0) resultList = resultList.concat(nodeLeave3List)
                    //虚拟概算价数据信息
                    if(nodeLeave3BudgetList.length < 1) nodeLeave3BudgetList = this.initNodeLeave3BudgetList(nodeLeave3List)
                    resultList = this.initNodeLeave210ResultList(resultList, v, 3, '1007002', '控制价', list)  //第3层信息
                }
                if(bidIndex > -1) {     //中标价
                    //第4层信息
                    let nodeLeave3List = list.filter(function(sv) {return sv != null && sv.proTreeLevelType==3 && sv.proTreeParentId == v.proTreeId && sv.phase == '1007003' && sv.unitParentId!=0 && sv.proTreeName.substring(0,6) != "工程造价调整"})
                    if(nodeLeave3List.length > 0) resultList = resultList.concat(nodeLeave3List)
                    //虚拟概算价数据信息
                    if(nodeLeave3BudgetList.length < 1) nodeLeave3BudgetList = this.initNodeLeave3BudgetList(nodeLeave3List)
                    resultList = this.initNodeLeave210ResultList(resultList, v, 3, '1007003', '中标价', list)
                }
                if(reportIndex > -1) {  //报审价
                    //第4层信息
                    let nodeLeave3List = list.filter(function(sv) {return sv != null && sv.proTreeLevelType==3 && sv.proTreeParentId == v.proTreeId && sv.phase == '1007004' && sv.unitParentId!=0 && sv.proTreeName.substring(0,6) != "工程造价调整"})
                    if(nodeLeave3List.length > 0) resultList = resultList.concat(nodeLeave3List)
                    //虚拟概算价数据信息
                    if(nodeLeave3BudgetList.length < 1) nodeLeave3BudgetList = this.initNodeLeave3BudgetList(nodeLeave3List)
                    resultList = this.initNodeLeave210ResultList(resultList, v, 3, '1007004', '报审价', list)
                }
                if(primeIndex > -1) {   //初审价
                    //第4层信息
                    let nodeLeave3List = list.filter(function(sv) {return sv != null && sv.proTreeLevelType==3 && sv.proTreeParentId == v.proTreeId && sv.phase == '1007005' && sv.unitParentId!=0 && sv.proTreeName.substring(0,6) != "工程造价调整"})
                    if(nodeLeave3List.length > 0) resultList = resultList.concat(nodeLeave3List)
                    //虚拟概算价数据信息
                    if(nodeLeave3BudgetList.length < 1) nodeLeave3BudgetList = this.initNodeLeave3BudgetList(nodeLeave3List)
                    resultList = this.initNodeLeave210ResultList(resultList, v, 3, '1007005', '初审价', list)
                }
                if(confirmIndex > -1) { //审定价
                    //第4层信息
                    let nodeLeave3List = list.filter(function(sv) {return sv != null && sv.proTreeLevelType==3 && sv.proTreeParentId == v.proTreeId && sv.phase == '1007006' && sv.unitParentId!=0 && sv.proTreeName.substring(0,6) != "工程造价调整"})
                    if(nodeLeave3List.length > 0) resultList = resultList.concat(nodeLeave3List)
                    //虚拟概算价数据信息
                    if(nodeLeave3BudgetList.length < 1) nodeLeave3BudgetList = this.initNodeLeave3BudgetList(nodeLeave3List)
                    resultList = this.initNodeLeave210ResultList(resultList, v, 3, '1007006', '审定价', list)
                }
                //第4层概算价信息
                if(nodeLeave3BudgetList.length > 0) resultList = resultList.concat(nodeLeave3BudgetList)
                //第3层概算价信息
                let cv = JSON.parse(JSON.stringify(v))
                cv.phase = '1007001'
                cv.phaseName = "概算价"
                cv.unitCostValue = parseFloat(v.budgetCostValueLevel2).toFixed(2)
                resultList.push(cv)
            })

            budgetIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007001' && v.proTreeLevelType == 2}) //概算价
            controlIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007002' && v.proTreeLevelType == 2})//控制价
            bidIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007003' && v.proTreeLevelType == 2})    //中标价
            reportIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007004' && v.proTreeLevelType == 2}) //报审价
            primeIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007005' && v.proTreeLevelType == 2})  //初审价
            confirmIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007006' && v.proTreeLevelType == 2})//审定价
            //计算项目结构树第二层级价格（proTreeLevelType = 1），累加proTreeLevelType=2的价格
            let nodeLeave1List = list.filter(v=> {return v != null && v.proTreeLevelType==1})
            nodeLeave1List.forEach(v => {
                if(budgetIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 2, '1007001', '概算价', [])
                if(controlIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 2, '1007002', '控制价', [])
                if(bidIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 2, '1007003', '中标价', [])
                if(reportIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 2, '1007004', '报审价', [])
                if(primeIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 2, '1007005', '初审价', [])
                if(confirmIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 2, '1007006', '审定价', [])
            })

            budgetIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007001' && v.proTreeLevelType == 1}) //概算价
            controlIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007002' && v.proTreeLevelType == 1})//控制价
            bidIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007003' && v.proTreeLevelType == 1})    //中标价
            reportIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007004' && v.proTreeLevelType == 1}) //报审价
            primeIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007005' && v.proTreeLevelType == 1})  //初审价
            confirmIndex = resultList.findIndex((v, index, arr) => {return v.phase == '1007006' && v.proTreeLevelType == 1})//审定价
            //计算项目结构树第一层级价格（proTreeLevelType = 0），累加proTreeLevelType=1的价格
            let nodeLeave0List = list.filter(v=> {return v != null && v.proTreeLevelType==0})
            nodeLeave0List.forEach(v => {
                if(budgetIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 1, '1007001', '概算价', [])
                if(controlIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 1, '1007002', '控制价', [])
                if(bidIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 1, '1007003', '中标价', [])
                if(reportIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 1, '1007004', '报审价', [])
                if(primeIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 1, '1007005', '初审价', [])
                if(confirmIndex > -1) resultList = this.initNodeLeave210ResultList(resultList, v, 1, '1007006', '审定价', [])
            })

            return resultList
        },
        //计算项目结构树第二层级价格（proTreeLevelType = 1），累加proTreeLevelType = 2的价格
        //计算项目结构树第一层级价格（proTreeLevelType = 0），累加proTreeLevelType = 1的价格
        initNodeLeave210ResultList(transResultList, node, proTreeLevelType, phase, phaseName, list){
            let resultList = transResultList.concat()
            let nodeLeaveList = []
            if(proTreeLevelType == 3) nodeLeaveList = list.filter(function(sv) {return sv != null && sv.proTreeLevelType == proTreeLevelType && sv.proTreeParentId == node.proTreeId && sv.phase == phase && sv.unitParentId==0 && sv.proTreeName.substring(0,6) != "工程造价调整" })
            else nodeLeaveList = resultList.filter(function(sv) {return sv.proTreeLevelType == proTreeLevelType && sv.proTreeParentId == node.proTreeId && sv.phase == phase})
            let moneySum = 0;
            nodeLeaveList.forEach((item)=>{ moneySum += parseFloat(item.unitCostValue) })
            let cv = JSON.parse(JSON.stringify(node))
            cv.unitCostValue = moneySum.toFixed(2)
            cv.phase = phase
            cv.phaseName = phaseName
            resultList.push(cv)
            return resultList
        },
        getChartsData(chartType){
            let that = this
            that.listData = []
            that.originalData = []
            sixCalculationAnalysis({ aid: this.curProjectId }).then(res => {
                if (res.code == 0) {
                    let analysisData = res.data.concat()
                    //let treeData = this.$utils.toArrayTree(analysisData, { key: 'proTreeId', parentKey: 'proTreeParentId', children: 'children' });
                    //that.originalData = treeData.concat()
                    //项目结构1、2层级，计算累加子节点价格
                    that.listData = this.projectStructureLevel0l2PriceSum(analysisData)

                    setTimeout(() => {
                        that.initCharts(chartType,that.rowNodeId)
                    }, 300)
                }
            })
        },
        initCharts(chartType, pid){
            this.chartType = chartType
            if(chartType=='pie'){   //饼状图
                // 概算价 图表
                this.budgetChart = this.$echarts.init(document.getElementById('budgetChart'))
                this.budgetChart.clear()
                this.initChart(chartType, this.budgetChart, pid, 'budgetPrice')

                // 控制价
                this.controlChart = this.$echarts.init(document.getElementById('controlChart'))
                this.controlChart.clear()
                this.initChart(chartType, this.controlChart, pid, 'controlPrice')

                // 中标价
                this.bidChart = this.$echarts.init(document.getElementById('bidChart'))
                this.bidChart.clear()
                this.initChart(chartType, this.bidChart, pid, 'bidPrice')

                // 报审价
                this.reportChart = this.$echarts.init(document.getElementById('reportChart'))
                this.reportChart.clear()
                this.initChart(chartType, this.reportChart, pid, 'reportPrice')

                // 初审价
                this.primeChart = this.$echarts.init(document.getElementById('primeChart'))
                this.primeChart.clear()
                this.initChart(chartType, this.primeChart, pid, 'primePrice')

                // 审定价
                this.confirmChart = this.$echarts.init(document.getElementById('confirmChart'))
                this.confirmChart.clear()
                this.initChart(chartType, this.confirmChart, pid, 'confirmPrice')

                setTimeout(() => {
                    //图表自适应
                    this.budgetChart.resize()       // 概算价
                    this.controlChart.resize()      // 控制价
                    this.bidChart.resize()          // 中标价
                    this.reportChart.resize()       // 报审价
                    this.primeChart.resize()        // 初审价
                    this.confirmChart.resize()      // 审定价
                    //左边项目树信息高度自适应
                    this.leftResize()

                    // 窗口移动事件
                    window.onresize = () => {
                        this.budgetChart.resize()       // 概算价
                        this.controlChart.resize()      // 控制价
                        this.bidChart.resize()          // 中标价
                        this.reportChart.resize()       // 报审价
                        this.primeChart.resize()        // 初审价
                        this.confirmChart.resize()      // 审定价
                        //左边项目树信息高度自适应
                        this.leftResize()
                    }
                }, 300)
            }else {     //柱状图
                let chart = document.getElementById('barChart')
                if (chart) {
                    this.barChart = this.$echarts.init(chart)
                    this.barChart.clear()
                    this.initChart(chartType, this.barChart, pid, 'budgetPrice')


                    setTimeout(() => {
                        this.barChart.resize()
                        //左边项目树信息高度自适应
                        this.leftResize()

                        // 窗口移动事件
                        window.onresize = () => {
                            //左边项目树信息高度自适应
                            this.leftResize()
                            this.barChart.resize()
                        }
                    }, 300)
                }
            }
        },
        initChart(type, eChart, pid, chartClass){
            let that = this
            let titleObj = {budgetPrice: '概算价',controlPrice: '控制价',bidPrice: '中标价',reportPrice: '报审价',primePrice: '初审价',confirmPrice: '审定价'}

            // 定义数组
            let barList = []    //折线图数据源
            let dataSource = [] //饼图数据源
            let legendArr = []
            if(type === 'pie'){ //饼图
                let chartValues = this.chartPriceArr.filter(x => {return x.key == chartClass})
                let chartValue = ""
                if(chartValues.length > 0) chartValue = chartValues[0].value
                this.listData.forEach(v=>{
                    if(v.proTreeParentId == pid && v.phase == chartValue) {
                        legendArr.push(v.proTreeName)
                        let item = { name: v.proTreeName, value: v.unitCostValue }
                        dataSource.push(item)
                    }
                })
                //legendArr.sort((a, b)=> a.localeCompare(b, 'zh')); //z~a 排序
                //dataSource.sort((a, b)=> a.name.localeCompare(b.name, 'zh')); //z~a 排序
            }else {     //折线图
                let barColorList = ['#CDD169','#6F9EA7','#C6866D','#91C5AF','#1193cf','#65c5bd','#ca88c8','#BA55D3','#9370DB','#6495ED','#40E0D0','#F0E68C','#F4A460','#6495ED','#7B68EE',]
                legendArr = ['概算价','控制价','中标价','报审价','初审价','审定价']
                let names = []
                //子节点所有list信息
                let barListData = this.listData.filter(v => v.proTreeParentId == pid)
                names = barListData.map((item,index,arr) => {return item.unitCostName != null? item.unitCostName:item.proTreeName})
                names = Array.from(new Set(names))  //去重
                //获取names 对应的价格之和
                names.forEach(function(name,index){
                    let item = that.barChartDataUnit(barListData, name, barColorList, index)
                    barList.push(item)
                })
            }

            let activeOption = {}
            // 如果是饼图
            if (type === 'pie') {
                let colorList = ['#399be1','#36cbcb','#4ecb73','#fbd437','#da6fad','#88b4ca','#d18061','#65c5bd','#4fcce7','#d16361','#b38661','#40E0D0','#F0E68C','#F4A460','#6495ED','#7B68EE',]
                activeOption = {
                    legend: {
                        bottom: 20,
                        type: 'scroll',
                        data: legendArr,
                    },
                    title: {
                        text: chartClass === 'budgetPrice' ? '' : titleObj[chartClass],
                        textAlign: 'center',
                        top: '5px',
                        left: '50%'
                    },
                    tooltip: {
                        formatter: function(params) {
                            //let value = params.value[params.encode.value[0]]
                            //return `${params.name}: ${value} 元 </br>占比： ${params.percent} %`
                            return `${params.name}: ${params.value} 元 </br>占比： ${params.percent} %`
                        }
                    },
                    toolbox: {
                        feature: {
                            myTool1: {
                                show: true,
                                title: '查看大图',
                                icon:
                                    'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                                onclick: () => {
                                    // 展示大图
                                    this.changeEnlarge(chartClass)
                                    // this.$message.warning('等待中...')
                                }
                            }
                        },
                        top: 18
                    },
                    dataset: {
                    },
                    series: [
                        {
                            type: 'pie',
                            data: dataSource,
                            radius: 90,
                            encode: {
                                itemName: 'sname',
                                value: chartClass
                            },
                            label: {
                                normal: {
                                    formatter: `{b|{b}}\n{hr|}\n{value|{@${chartClass}} 元}`,
                                    // formatter: `{b}{@${chartClass}} 元`,
                                    rich: {
                                        b: {
                                            lineHeight: 20
                                        },
                                        hr: {
                                            borderColor: '#5f9ea0',
                                            width: '100%',
                                            borderWidth: 0.5,
                                            height: 0,
                                            marginTop: 3
                                        },
                                        value: {
                                            lineHeight: 20
                                        }
                                    }
                                }
                            },
                            itemStyle: {
                                normal: {
                                    // 饼图块
                                    color: function(params) {
                                        if(params.dataIndex <= colorList.length - 1) return colorList[params.dataIndex]
                                        else return colorList[params.dataIndex - colorList.length]
                                    }
                                }
                            }
                        }
                    ]
                }
            } else {
                // 如果是折线图
                activeOption = {
                    legend: {
                        top: '40px'
                    },
                    title: {
                        text: this.rowNodeName + '价格构成',
                        textAlign: 'center',
                        top: '5px',
                        left: '50%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        },
                         textStyle:{
                         　　align:'left'
                         }
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                title: '保存为png',
                                pixelRatio: 2
                            },
                            magicType: {
                                type: ['line', 'bar', 'stack', 'tiled']
                            }
                        }
                    },
                    grid: {
                        top: '100px',
                        left: '15px',
                        right: '4%',
                        bottom: '10px',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false, // 坐标轴两边是否 留白
                            data: legendArr,
                        }
                    ],
                    yAxis: {
                        type: 'value'
                    },
                    series: barList
                }
            }
            eChart.setOption(activeOption)
        },
        //折线图数据处理
        barChartDataUnit(barListData, name, barColorList, index){
            let budgetBarList = barListData.filter(v=> v.unitCostName != null ? v.unitCostName == name && v.phase == '1007001' : v.proTreeName == name && v.phase == '1007001')
            let controlBarList = barListData.filter(v=> v.unitCostName != null ? v.unitCostName == name && v.phase == '1007002' : v.proTreeName == name && v.phase == '1007002')
            let bidBarList = barListData.filter(v=> v.unitCostName != null ? v.unitCostName == name && v.phase == '1007003' : v.proTreeName == name && v.phase == '1007003')
            let reportBarList = barListData.filter(v=> v.unitCostName != null ? v.unitCostName == name && v.phase == '1007004' : v.proTreeName == name && v.phase == '1007004')
            let primeBarList = barListData.filter(v=> v.unitCostName != null ? v.unitCostName == name && v.phase == '1007005' : v.proTreeName == name && v.phase == '1007005')
            let confirmBarList = barListData.filter(v=> v.unitCostName != null ? v.unitCostName == name && v.phase == '1007006' : v.proTreeName == name && v.phase == '1007006')
            let item = {
                type: 'line',
                seriesLayoutBy: 'row',
                stack: '结构',
                name: name,
                areaStyle: {},
                itemStyle: {color: barColorList[index]},
                barMaxWidth: 30,
                data : []
            }

            let data = []
            //概算价
            this.getCostData(data, budgetBarList)
            //控制价
            this.getCostData(data, controlBarList)
            //中标价
            this.getCostData(data, bidBarList)
            //报审价
            this.getCostData(data, reportBarList)
            //初审价
            this.getCostData(data, primeBarList)
            //审定价
            this.getCostData(data, confirmBarList)

            item.data = data

            return item;
        },
        getCostData(data, itemBarList){
            let costValue = 0.0
            if(itemBarList.length > 0){
                itemBarList.forEach(bb=>{costValue += parseFloat(bb.unitCostValue)})
                costValue.toFixed(2)
            }
            data.push(costValue)
            return data;
        },
        //总概算/建安概算 切换
        showTotalOrEstimate(type){
            let _chart = this.$echarts.init(document.getElementById('budgetChart'))
            if (type === 'total') {
                _chart.clear()
                this.initTotalChart(_chart)
            } else {
                _chart.clear()
                this.initChart('pie',_chart, this.rowNodeId, 'budgetPrice')
            }
        },
        initTotalChart(eChart){
            let that = this
            let activeOption = {}

            let colorList = ['#399be1','#36cbcb','#4ecb73','#fbd437','#da6fad','#88b4ca','#d18061','#65c5bd','#4fcce7','#d16361','#b38661','#40E0D0','#F0E68C','#F4A460','#6495ED','#7B68EE',]

            activeOption = {
                legend: {
                    bottom: 20
                },
                title: {
                    text: '',
                    textAlign: 'center',
                    top: '5px',
                    left: '50%'
                },
                tooltip: {
                    formatter: function(params) {
                        return `${params.name}: ${params.value} 元 </br>占比： ${params.percent} %`
                    }
                },
                toolbox: {
                    feature: {
                        myTool1: {
                            show: true,
                            title: '查看大图',
                            icon:
                                'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                            onclick: () => {
                                // 展示大图
                                this.changeEnlarge('totalEstimate')
                                // this.$message.warning('等待中...')
                            }
                        }
                    },
                    top: 18
                },
                series: [
                    {
                        type: 'pie',
                        name: '总概算',
                        radius: 90,

                        label: {
                            normal: {
                                formatter: `{b|{b}}\n{hr|}\n{value|{c}}元`,
                                // formatter: `{b}{@${attr}} 元`,
                                rich: {
                                    b: {
                                        lineHeight: 20
                                    },
                                    hr: {
                                        borderColor: '#5f9ea0',
                                        width: '100%',
                                        borderWidth: 0.5,
                                        height: 0,
                                        marginTop: 3
                                    },
                                    value: {
                                        lineHeight: 20
                                    }
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                // 饼图块
                                color: function(params) {
                                    if(params.dataIndex <= colorList.length - 1) return colorList[params.dataIndex]
                                    else return colorList[params.dataIndex - colorList.length]
                                }
                            }
                        },
                        data: this.totalEstimateData
                    }
                ]
            }
            eChart.setOption(activeOption)

            eChart.resize()
            setTimeout(() => {
                // 窗口移动事件
                window.onresize = () => {
                    eChart.resize()       // 概算价
                    //左边项目结构自适应
                    that.leftResize()
                }
            }, 300)
        },

        changeEnlarge(chartClass){
            this.showBigger = true

            setTimeout(() => {
                let _item = document.getElementById('enlarge_chart')
                if (_item) {
                    this.enlargeChart = this.$echarts.init(_item)
                    this.enlargeChart.clear()

                    chartClass !== 'totalEstimate'
                        ? this.initBigChart(this.enlargeChart, this.rowNodeId, chartClass)
                        : this.initBigTotal(this.enlargeChart)

                    setTimeout(() => {
                        this.enlargeChart.resize()
                        // 窗口移动事件
                        window.onresize = () => {
                            this.enlargeChart.resize()
                        }
                    }, 300)
                }
            }, 300)
        },
        // 渲染大图
        initBigChart(eChart, pid, chartClass) {
            let titleObj = {totalEstimate: '总概算',budgetPrice: '概算价',controlPrice: '控制价',biddingPrice: '中标价',reportPrice: '报审价',beforePrice: '初审价',afterPrice: '审定价'}
            // 获得对应的数据
            let legendArr = []
            let dataSource = []
            let chartValues = this.chartPriceArr.filter(x => {return x.key == chartClass})
            let chartValue = ""
            if(chartValues.length > 0) chartValue = chartValues[0].value
            this.listData.forEach(v=>{
                if(v.proTreeParentId == pid && v.phase == chartValue) {
                    legendArr.push(v.proTreeName)
                    let item = { name: v.proTreeName, value: v.unitCostValue }
                    dataSource.push(item)
                }
            })
            //legendArr.sort((a, b)=> a.localeCompare(b, 'zh')); //z~a 排序
            //dataSource.sort((a, b)=> a.name.localeCompare(b.name, 'zh')); //z~a 排序

            let colorList = ['#399be1','#36cbcb','#4ecb73','#fbd437','#da6fad','#88b4ca','#d18061','#65c5bd','#4fcce7','#d16361','#b38661','#40E0D0','#F0E68C','#F4A460','#6495ED','#7B68EE']
            let activeOption = {
                legend: {
                    top: '8%',
                    left: 20,
                    orient: 'vertical',
                    data : legendArr,
                    type: 'scroll'
                },
                title: {
                    text: this.rowNodeShowName,
                    subtext: titleObj[chartClass],
                    subtextStyle: {
                        color: '#666',
                        fontSize: 13
                    },
                    textAlign: 'center',
                    top: '5px',
                    left: '50%'
                },
                tooltip: {
                    formatter: function(params) {
                        //let value = params.value[params.encode.value[0]]
                        let value = params.value
                        return `${params.name}: ${value} 元 </br>占比： ${params.percent} %`
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '保存为png',
                            pixelRatio: 2
                        }
                    },
                    top: 20
                },
                // 配置图层
                graphic: {
                    type: 'text',
                    left: 10, // 相对父元素居中
                    bottom: '5%', // 相对父元素居中
                    // invisible: this.isVisible ? false : true,
                    style: {
                        fill: '#333',
                        text: [`导出人：${this.userName}`, '导出时间：' + dateFormatCN()].join(      // getDayTime()
                            '\n'
                        ),
                        font: '14px Microsoft YaHei'
                    }
                },
                dataset: {

                },
                series: [
                    {
                        type: 'pie',
                        data: dataSource,
                        radius: 150,
                        encode: {
                            itemName: 'sname',
                            value: chartClass
                        },
                        label: {
                            normal: {
                                formatter: `{b|{b}}\n{hr|}\n{value|{@${chartClass}} 元}`,
                                // formatter: `{b}{@${attr}} 元`,
                                rich: {
                                    b: {
                                        lineHeight: 20
                                    },
                                    hr: {
                                        borderColor: '#5f9ea0',
                                        width: '100%',
                                        borderWidth: 0.5,
                                        height: 0,
                                        marginTop: 3
                                    },
                                    value: {
                                        lineHeight: 20
                                    }
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                // 饼图块
                                color: function(params) {
                                    if(params.dataIndex <= colorList.length - 1) return colorList[params.dataIndex]
                                    else return colorList[params.dataIndex - colorList.length]
                                }
                            }
                        }
                    }
                ]
            }

            eChart.setOption(activeOption)

            // this.showBigger = true
        },

        // 渲染 总概算大图
        initBigTotal(eChart) {
            let chartData = this.totalEstimateData

            let colorList = ['#399be1','#36cbcb','#4ecb73','#fbd437','#da6fad','#88b4ca','#d18061','#65c5bd','#4fcce7','#d16361','#b38661','#40E0D0','#F0E68C','#F4A460','#6495ED','#7B68EE']

            let activeOption = {
                legend: {
                    top: '8%',
                    left: 20,
                    orient: 'vertical'
                },
                title: {
                    text: this.curShowName,
                    subtext: '总概算',
                    subtextStyle: {
                        color: '#666',
                        fontSize: 13
                    },
                    textAlign: 'center',
                    top: '5px',
                    left: '50%'
                },
                tooltip: {
                    formatter: function(params) {
                        return `${params.name}: ${params.value} 元 </br>占比： ${params.percent} %`
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '保存为png',
                            pixelRatio: 2
                        }
                    },
                    top: 20
                },
                // 配置图层
                graphic: {
                    type: 'text',
                    left: 10, // 相对父元素居中
                    bottom: '5%', // 相对父元素居中
                    // invisible: this.isVisible ? false : true,
                    style: {
                        fill: '#333',
                        text: ['导出人：xx', '导出时间：' + dateFormatCN()].join(      //getDayTime()
                            '\n'
                        ),
                        font: '14px Microsoft YaHei'
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: 150,
                        label: {
                            normal: {
                                formatter: `{b|{b}}\n{hr|}\n{value|{c}}元`,
                                // formatter: `{b}{@${attr}} 元`,
                                rich: {
                                    b: {
                                        lineHeight: 20
                                    },
                                    hr: {
                                        borderColor: '#5f9ea0',
                                        width: '100%',
                                        borderWidth: 0.5,
                                        height: 0,
                                        marginTop: 3
                                    },
                                    value: {
                                        lineHeight: 20
                                    }
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                // 饼图块
                                color: function(params) {
                                    if(params.dataIndex <= colorList.length - 1) return colorList[params.dataIndex]
                                    else return colorList[params.dataIndex - colorList.length]
                                }
                            }
                        },
                        data: chartData
                    }
                ]
            }

            eChart.setOption(activeOption)
        },

        exportChart(rowNodeShowName, rowNodeName){
            let _barChart = this.$echarts.init(document.getElementById('barChart'))
            _barChart.setOption({
                title: {
                    text: rowNodeShowName
                }
            })

            let anchor = document.createElement('a')
            // a 标签属性
            anchor.download = rowNodeShowName + '.png'
            anchor.href = _barChart.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
                excludeComponents: ['toolbox']
            })
            anchor.click()

            setTimeout(() => {
                _barChart.setOption({
                    title: {
                        text: rowNodeName + '价格构成'
                    }
                })
            }, 300)
        },

        //左边项目结构自适应
        leftResize(){
            this.$emit('left-resize')
        },

        //左侧点击展示/隐藏，图表自适应
        leftShowResize(){
            setTimeout(() => {
                //let _chart = this.$echarts.init(document.getElementById('budgetChart'))
                this.budgetChart.resize()
                this.controlChart.resize()
                this.bidChart.resize()
                this.reportChart.resize()
                this.primeChart.resize()
                this.confirmChart.resize()
                this.budgetChart.resize()
                if(this.chartType=='bar') this.barChart.resize()
                if(this.showBigger) this.enlargeChart.resize()
            }, 500)
        },
    }
}
</script>

<style lang="less" scoped>
.main-page{
    height : 100%;
        width : 100%;
        box-sizing: border-box;
        padding : 5px 0px 0px;

        .pie-chart{
            height : 100%;
            box-sizing : border-box;

            .title{
                position: absolute;
                left: 16.67%;
                top: 48px;
                transform: translateX(-50%);
                z-index: 1;

                .btn-text{
                    color: #333;
                    font-size: 18px;
                    font-weight: 700;
                }
            }

            .chart-component{
                height : 50%;
                width : 33.33%;
                box-sizing : border-box;
                float : left;
                display: flex;
                justify-content:center;
                align-items:Center;
            }

            .chart1{
                border-right: 1px solid #F0F0F5;
                border-bottom: 1px solid #F0F0F5;
            }
            .chart2{
                border-right: 1px solid #F0F0F5;
                border-bottom: 1px solid #F0F0F5;
            }
            .chart3{
                border-bottom: 1px solid #F0F0F5;
            }

            .chart4{
                border-right: 1px solid #F0F0F5;
            }
            .chart5{
                border-right: 1px solid #F0F0F5;
            }
        }

        .bar-chart{
            height : 100%;
            box-sizing : border-box;

            .bar-chart-component{
                height : 100%;
                width : 100%;
                box-sizing : border-box;
                display: flex;
                justify-content:center;
                align-items:Center;
            }
        }

        .big-picture-modal{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;

            display: flex;
            justify-content: center;
            align-items: center;

            width: 100%;
            height: 100%;

            background: hsla(0, 0, 0, 0.6);

            .content{
                height : 90%;
                width : 80%;
                background : #fff;

                .title {
                    height: 40px;
                    line-height: 40px;
                    padding: 0 10px;
                    font-size: 18px;
                    color: #333;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    justify-content: space-between;
                    border-bottom: 1px solid #ddd;

                    .el-icon-close{
                        display: flex;
                        -webkit-box-align: center;
                        align-items: center;
                        cursor: pointer;
                    }
                }

                .enlargeChart{
                    height : calc(~'100% - 40px');
                }
            }
        }
}
</style>